module.exports = __webpack_public_path__ + "static/MdTariqueEbrahim-e7bd35cf5e911eaa9e213579a9784ce4.jpg";